


































import { Component, Mixins, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import CompanyService from "../services/company.service";
import { CompanyModel } from "../models/CompanyModel";
import eventBus from "../common/bus";
import Shared from "../common/shared";

@Component({
  components: {
    ValidationObserver,
  },
})
export default class Accounts extends Mixins(BaseServiceMixin) {
  private companyService!: CompanyService;
  private companyDetails: CompanyModel = new CompanyModel();

  private get company(): CompanyModel | null {
    return this.vuexStore.company;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private get companyDetailsObserver(): any {
    return this.$refs.companyDetailsObserver;
  }

  public created() {
    this.companyService = new CompanyService(this.axiosInstance);
  }

  private async mounted() {
    await this.updateInternalStorage();
  }

  @Watch("company", { deep: true })
  private async updateInternalStorage() {
    if (!this.company || !this.company.id) {
      return;
    }
    this.companyDetails = Object.assign(new CompanyModel(), this.company);
  }

  private async saveCompany() {
    eventBus.$emit("loading", true);
    try {
      let details: CompanyModel | null = null;
      if (this.company && this.company.id) {
        details = await this.companyService.updateCompany(this.companyDetails);
      } else {
        const companyDetail: CompanyModel = await this.companyService.createCompany(this.companyDetails);
        details = companyDetail;
      }

      this.vuexStore.setCompany(details);
    } catch (error) {
      if (error.name === Shared.conflict) {
        Shared.showToastMessage(error.message || Shared.messages.COMPANY_CONFLICT, "is-danger");
      } else {
        Shared.showToastMessage(Shared.messages.BASIC_COMPANY_SAVE_ERROR, "is-danger");
      }
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private resetCompanyForm() {
    this.companyDetails.name = "";
    this.companyDetails.website = "";
    this.companyDetailsObserver.reset();
  }
}
